<app-page-template
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [config]="pageConfig"
  (onAdd)="onCreate()"
  (sortObject)="getSortItems($event)"
  (onShowAuditPage)="onShowAuditPage()"
  (onShowHelpPage)="onShowHelpPage()"
  (comparisonObjects)="getComparisonObjects($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
  [class]="isVisibleHelpForm || isShowMenuHelps ? 'd-none' : ''"
>
  <!-- custom header -->
  <app-page-header
    custom-header
    [title]="pageConfig.title"
    [loading]="pageConfig.loading"
    [showAuditBtn]="pageConfig?.showAuditBtn"
    [showHelpBtn]="pageConfig?.showHelpBtn"
    (onAdd)="onCreate()"
    (onShowAudit)="onShowAuditPage()"
    (onShowHelp)="onShowHelpPage()"
  >
    <div before-btns>
      <!-- refresh btn -->
      <button
        (click)="onRefreshMenus()"
        class="btn btn-light txt-lg button-shadow tw-mx-1 btn-hover-rise"
        type="button"
        mat-ripple
        [matTooltip]="'common.refreshMenus' | translate"
      >
        <i class="mdi mdi-refresh mdi-20px tw-p-0 text-blue"></i>
      </button>
    </div>
  </app-page-header>

  <!--------------------------------------------------------------- Table Content ---------------->
  <ng-container table-body *ngIf="(items$ | async) && !pageConfig.loading">
    <ng-container *ngFor="let item of items$ | async; let i = index">
      <tr
        #row
        (click)="onActiveRow(row, i)"
        [class.row-active]="rowIndexSelected == i"
      >
        <!-- index -->
        <td class="tw-text-center !tw-p-4">
          {{ paginationModel?.firstIndex + i }}
        </td>

        <!-- title -->
        <td>
          <td-value
            class="font-vazir-ui"
            copyToClipboard
            [value]="item?.title"
          ></td-value>
        </td>

        <!-- parentTitle -->
        <td class="tw-dir-rtl ltr:tw-dir-ltr tw-text-center">
          <td-value
            class="font-vazir-ui"
            copyToClipboard
            [value]="item?.parentTitle"
          ></td-value>
        </td>

        <!-- route -->
        <td class="tw-dir-rtl ltr:tw-dir-ltr tw-text-center">
          <td-value
            class="font-vazir-ui"
            copyToClipboard
            [value]="item?.route"
          ></td-value>
        </td>

        <!-- created -->
        <td>
          <td-value type="dateTime" [value]="item?.created"></td-value>
        </td>

        <!------------------------------- operations -------------------------------->
        <td class="sticky-td">
          <div
            app-menu-btn
            [matMenuTriggerFor]="menu"
            [isShowDotsMenu]="true"
          ></div>

          <mat-menu #menu="matMenu" xPosition="before">
            <!-- edit button -->
            <div app-menu-btn icon="edit" (click)="onUpdate(item.id)"></div>

            <!-- menu helps button -->
            <div
              app-menu-btn
              *ngIf="userSession.organizationId() == 1"
              icon="mdi mdi-table-question mdi-20px"
              color="indigo"
              [title]="'common.editHelp'"
              (click)="onMenuHelps(item.id)"
            ></div>

            <!-- delete button -->
            <div
              app-menu-btn
              icon="delete"
              (click)="onDelete(item.id, item.title)"
            ></div>
          </mat-menu>
        </td>
      </tr>
    </ng-container>
  </ng-container>
</app-page-template>

<!-- form -->
<ng-container *ngIf="pageConfig?.isVisibleForm">
  <app-menus-form
    page-form
    [formPageConfig]="formPageConfig"
    (closeFormPage)="getFormResponse($event)"
  >
  </app-menus-form>
</ng-container>

<!--------------------------------------------------------------- Audit ---------------->
<ng-container *ngIf="pageConfig?.isVisibleAuditPage">
  <app-audit
    [service]="currentService"
    [methodName]="auditApiMethodName"
    (hidePage)="onHideAuditPage()"
  >
  </app-audit>
</ng-container>

<!--------------------------------------------------------------- help ---------------->
<ng-container *ngIf="pageConfig?.isVisibleHelpPage">
  <app-help-page
    [menuTitle]="pageName"
    (hidePage)="onHideHelpPage()"
    [title]="pageConfig.title"
  >
  </app-help-page>
</ng-container>

<!--------------------------------------------------------------- menu helps ---------------->
<ng-container *ngIf="isShowMenuHelps">
  <app-menu-helps-form
    [menuHelpsData]="menuHelpsData"
    [menuId]="menuId"
    (closeFormPage)="isShowMenuHelps = false"
  >
  </app-menu-helps-form>
</ng-container>
